import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {UserService} from "../../../@shared/services/user.service";
import {IUser} from "../../../@core/interfaces/user/user.interface";
import {MatDialog} from "@angular/material/dialog";
import {AuthHistoryComponent} from "../modals/auth-history/auth-history.component";
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {AuthUserService} from "../../../@shared/services/auth/auth-user.service";
import {canAccessVipUserSection} from "../../../@shared/constants/vip-access";

@Component({
  selector: 'app-user-content',
  templateUrl: './user-content.component.html',
  styleUrls: ['./user-content.component.scss']
})
export class UserContentComponent implements OnDestroy {
  @ViewChild('value', {static: false}) value!: ElementRef;
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public canAccessVip: boolean = false;
  public hasRefundIssue$!: Observable<boolean>;
  public user: IUser | null = null;
  public isHideWarning: boolean = false;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private userService: UserService,
              private dialog: MatDialog,
              private activatedRoute: ActivatedRoute,
              private authUserService: AuthUserService,
              private elRef: ElementRef) {
    this.subscribeEmitters();

    this.activatedRoute.paramMap
      .subscribe((params: ParamMap) => {
          this.userService.resetUser();
          this.userService.currentUserId.next(Number(params.get('id')));
          this.userService.requestUser();
          this.hasRefundIssue$ = this.userService.checkUserSteam()
            .pipe(map((response: any) => response.success ? !response.hasRefund?.success : false))
        }
      )
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public openAuthHistory(): void {
    const params = {
      width: '500px',
      height: 'fit-content',
    }
    this.dialog.open(AuthHistoryComponent, params)
  }

  public toggleVerify(checked: boolean): any {
    this.userService.toggleVerify(checked).subscribe()
  }

  public resetFaucet(): void {
    this.userService.resetFaucet().subscribe(() => () => this.userService.requestUser());
  }

  public hideWarnings(): void {
    this.isHideWarning = !this.isHideWarning;
  }

  public scrollToTop(): void {
    this.elRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  public getTotalPayouts(): number {
    if (!this.user?.balanceTransactions) {
      return 0;
    }

    const finishedPayouts = Number(this.user.balanceTransactions.finished_payouts) || 0;
    const processPayouts = Number(this.user.balanceTransactions.process_payouts) || 0;

    return finishedPayouts + processPayouts;
  }

  private subscribeEmitters(): void {
    this.authUserService.user$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user) => this.canAccessVip = canAccessVipUserSection(environment.projectName, user));

    this.userService.user$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user: IUser | null) => {
          this.user = user;
          this.isHideWarning = false;
        }
      );
  }
}
